import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { useAmazonContext } from "../../Contexts/AmazonContext";

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: ${(props) =>
    props.isDarkMode ? "var(--background-dark)" : "var(--background-light)"};
`;

const Card = styled.div`
  background-color: ${(props) =>
    props.isDarkMode ? "#2c2c2c" : "white"};
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
  text-align: center;
`;

const CheckIcon = styled.div`
  font-size: 80px;
  color: #28a745;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  color: ${(props) =>
    props.isDarkMode ? "var(--font-dark)" : "var(--font-light)"};
  font-family: "Quicksand", sans-serif;
  font-size: 28px;
  margin-bottom: 20px;
  font-weight: 700;
`;

const Message = styled.p`
  color: ${(props) =>
    props.isDarkMode ? "var(--font-dark)" : "var(--font-light)"};
  font-family: "Quicksand", sans-serif;
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 30px;
`;

const HomeButton = styled.button`
  display: inline-block;
  background-color: #8747d4;
  color: white;
  padding: 15px 30px;
  border-radius: 8px;
  border: none;
  font-family: "Quicksand", sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #6535a0;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(135, 71, 212, 0.3);
  }
`;

const AccountDeleted = () => {
  const { isDarkMode } = useAmazonContext();
  const history = useHistory();

  const handleReturnHome = () => {
    // Navigate to the universal logout message page which will handle the logout process
    // Pass a query parameter to indicate this is from account deletion
    history.replace("/UniversalLogoutMessage?from=account-deletion");
  };

  return (
    <Container isDarkMode={isDarkMode}>
      <Card isDarkMode={isDarkMode}>
        <CheckIcon>✅</CheckIcon>
        <Title isDarkMode={isDarkMode}>Account Successfully Deleted</Title>
        <Message isDarkMode={isDarkMode}>
          Your account and all associated data have been permanently removed from our system. 
          We're sorry to see you go, and we hope you'll consider joining us again in the future.
        </Message>
        <Message isDarkMode={isDarkMode}>
          Thank you for being part of our learning community.
        </Message>
        <HomeButton onClick={handleReturnHome}>
          Return to Home
        </HomeButton>
      </Card>
    </Container>
  );
};

export default AccountDeleted;
